import React from 'react'
import {Icon} from '@chakra-ui/react'

const NumberAbsoluteIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <circle cx="10" cy="10.0002" r="10" fill="#76B82A" />
            <path
                d="M10.8114 14.1202V12.1162H6.80336V11.2402L10.3674 5.24024H11.8314V11.1202H13.1994V12.1162H11.8314V14.1202H10.8114ZM8.02736 11.1202H10.8114V6.35624L8.02736 11.1202Z"
                fill="white"
            />
        </Icon>
    )
}

export default NumberAbsoluteIcon
